import SendRoundedIcon from '@mui/icons-material/SendRounded'
import { IconButton, InputAdornment, TextField } from '@mui/material'
import type { KeyboardEvent } from 'react'
import { AppBox } from 'src/component/common/analog/molecule/AppBox'
import { ColorTokens } from 'src/feature/theme/model/Palette'

export type AssistantComposerProps = {
  input: string;
  placeholder: string;
  disabled: boolean;
  onInputChange: (value: string) => void;
  onSend: () => void;
};

export function AssistantComposer({
  input,
  placeholder,
  disabled,
  onInputChange,
  onSend,
}: AssistantComposerProps) {
  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      onSend()
    }
  }

  return (
    <AppBox sx={styles.inputRow}>
      <TextField
        fullWidth
        multiline
        maxRows={3}
        size="small"
        placeholder={placeholder}
        value={input}
        onChange={event => onInputChange(event.target.value)}
        onKeyDown={handleKeyDown}
        sx={styles.input}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                size="small"
                onClick={onSend}
                disabled={disabled}
                sx={styles.sendButton}
              >
                <SendRoundedIcon sx={{ fontSize: 16 }} />
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
    </AppBox>
  )
}

const styles = {
  inputRow: {
    width: '100%',
    padding: '10px 15px',
    backgroundColor: 'background.dark',
    borderTop: '1px solid rgba(0,0,0,0.07)',
  },
  input: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'background.paper',
      borderRadius: '10px',
      fontSize: 12,
    },
  },
  sendButton: {
    color: ColorTokens.primary500,
    '&:disabled': { color: 'text.disabled' },
  },
}
